<div class="themes-list row">
  @for (t of themes; track t) {
    <div class="{{itemClass}} themes-list-item cursor-pointer" (click)="onSelect(t)">
      <div class="theme-picture theme-picture-{{ t.id }}">
        <div class="theme-header" [style.background]="t.colors.main"></div>
        <div class="theme-nav" [style.background]="t.colors.main"></div>
        <div class="theme-background">
          <div class="theme-text long" [style.background]="t.colors.primary"></div>
          <div class="theme-text" [style.background]="t.colors.secondary"></div>
          <div class="theme-text short" [style.background]="t.colors.primary"></div>
        </div>
      </div>
      <div class="theme-name" [translate]="'App.Themes.' + t.id"></div>
    </div>
  }
</div>